// extracted by mini-css-extract-plugin
module.exports = {"toutCard":"ToutCard_toutCard__x1I0a global_cardHover__VD7I6","iconWrapper":"ToutCard_iconWrapper__3WNS_","isLogo":"ToutCard_isLogo__ij9Xr","icon":"ToutCard_icon__Q8Vpc"};